export default __webpack_public_path__ + "static/img/img_3.d8c7044.png";